import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const MenuPage = () => import('views/cdu/pages/menu/Menu')

const FmcOuter = () => import('views/cdu/pages/fmc/FmcOuter')
const FmcIndex = () => import('views/cdu/pages/fmc/FmcIndex')
const Ident = () => import('views/cdu/pages/fmc/initRef/Ident')
const Perf = () => import('views/cdu/pages/fmc/initRef/Perf')
const Pos = () => import('views/cdu/pages/fmc/initRef/Pos')
const Takeoff = () => import('views/cdu/pages/fmc/initRef/Takeoff')
const Approach = () => import('views/cdu/pages/fmc/initRef/Approach')
const Offset = () => import('views/cdu/pages/fmc/initRef/Offset')
const NavData = () => import('views/cdu/pages/fmc/initRef/NavData')
const MsgRecall = () => import('views/cdu/pages/fmc/initRef/MsgRecall')
const AltnDest = () => import('views/cdu/pages/fmc/initRef/AltnDest')
const NavStatus = () => import('views/cdu/pages/fmc/initRef/NavStatus')

const Clb = () => import('views/cdu/pages/fmc/funcPages/Clb')
const Crz = () => import('views/cdu/pages/fmc/funcPages/Crz')
const Rte = () => import('views/cdu/pages/fmc/funcPages/Rte')
const DepArr = () => import('views/cdu/pages/fmc/funcPages/DepArr')
const Des = () => import('views/cdu/pages/fmc/funcPages/Des')
const Forecast = () => import('views/cdu/pages/fmc/funcPages/Forecast')
const Fix = () => import('views/cdu/pages/fmc/funcPages/Fix')
const Hold = () => import('views/cdu/pages/fmc/funcPages/Hold')
const Legs = () => import('views/cdu/pages/fmc/funcPages/Legs')
const N1Limit = () => import('views/cdu/pages/fmc/funcPages/N1Limit')
const Prog = () => import('views/cdu/pages/fmc/funcPages/Prog')

const MaintIndex = () => import('views/cdu/pages/fmc/maint/Index')

const AcarsIndex = () => import('views/cdu/pages/acars/index')

const DfdauIndex = () => import('views/cdu/pages/dfdau/index')

const SetupOuter = () => import('views/cdu/pages/setup/SetupOuter')
const SetupIndex = () => import('views/cdu/pages/setup/pages/Index')
const About = () => import('views/cdu/pages/setup/pages/About')

const routes = [
  {
    path: '/menu',
    component: MenuPage,
  },
  {
    path: '/fmc',
    component: FmcOuter,
    children:[
      {
        path: 'index',
        component: FmcIndex
      },
      {
        path: 'ident',
        component: Ident
      },
      {
        path: 'perf',
        component: Perf
      },
      {
        path: 'pos',
        component: Pos
      },
      {
        path: 'takeoff',
        component: Takeoff
      },
      {
        path: 'approach',
        component: Approach
      },
      {
        path: 'offset',
        component: Offset
      },
      {
        path: 'navdata',
        component: NavData
      },
      {
        path: 'navstatus',
        component: NavStatus
      },
      {
        path: 'msgrecall',
        component: MsgRecall
      },
      {
        path: 'altndest',
        component: AltnDest
      },
      {
        path: 'rte',
        component: Rte
      },
      {
        path: 'clb',
        component: Clb
      },
      {
        path: 'crz',
        component: Crz
      },
      {
        path: 'des',
        component: Des
      },
      {
        path: 'forecast',
        component: Forecast
      },
      {
        path: 'deparr',
        component: DepArr
      },
      {
        path: 'fix',
        component: Fix
      },
      {
        path: 'hold',
        component: Hold
      },
      {
        path: 'legs',
        component: Legs
      },
      {
        path: 'n1limit',
        component: N1Limit
      },
      {
        path: 'prog',
        component: Prog
      },
      {
        path: 'maint',
        component: FmcOuter,
        children: [
          {
            path: '',
            redirect: 'index'
          },
          {
            path: 'index',
            component: MaintIndex
          }
        ]
      }
    ]
  },
  {
    path: '/acars',
    component: FmcOuter,
    children: [
      {
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        component: AcarsIndex
      }
    ]
  },
  {
    path: '/dfdau',
    component: FmcOuter,
    children: [
      {
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        component: DfdauIndex
      }
    ]
  },
  {
    path: '/setup',
    component: SetupOuter,
    children: [
      {
        path: 'index',
        component: SetupIndex
      },
      {
        path: 'about',
        component: About
      },
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/mcdu_737ng/',
  routes
})

export default router